import { Injectable } from '@tanbo/vue-di-plugin'
import { Http } from '@/services/http'
import { BaselineItemTreeOperationService } from '@/views/dashboard/safe-status/base-line/_components/repair-item-drawer/baseline-item-tree-operation.service'
import { RepairTreeItem } from '@/views/dashboard/safe-status/base-line/repair-item-tree-type'

export interface RequestParams {
  /** 终端ID */
  device_id?: string
}

export interface ResponseData {
  /** 不合规的ID，e.g：["1.1.1","1.2.1","2.1 */
  substandard_ids: string[]
  /** 扫描的ID */
  check_item_ids: string[]
  // 扫描时间
  check_time: string
}

export interface Device {
  /** 终端ID */
  device_id: string
  /** 计算机名 */
  computer_name: string
  /** 所属分组 */
  group_name: string
  /** 登记用户名 */
  user_mark: string
  /** 外网ip地址 */
  client_ip: string
  /** 内网ip地址 */
  system_ip: string
  /** 操作系统 */
  system_name: string
  /** 终端状态 1：在线，2：离线 */
  device_status: number
  /** 扫描时间 */
  check_time: number
  /** 不合规数量 */
  substandard_num: number
}

@Injectable()
export class BaselinecheckResultSubstandardService extends BaselineItemTreeOperationService {
  constructor (private http: Http) {
    super()
  }

  getBaselinecheckResultSubstandard (data: RequestParams) {
    return this.http.post<ResponseData>('/baselinecheck/result/substandard', data)
  }

  generateRenderTree (category: RepairTreeItem[], ids: string[], fatherName = '') {
    return this.generateSecondTree(this.generateOriginalTreeWithIds(JSON.parse(JSON.stringify(category)), ids, fatherName))
  }
}
